import { JSX } from "react";
import { Link } from 'react-router-dom'
import { ProviderSetSimpleModel } from "./providerSet";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

export default function ProviderSetIconBox(providerSet: ProviderSetSimpleModel, location: string): JSX.Element {
  return (
    <div data-bs-animation-effect="fadeInUpSmall" data-bs-effect-delay="0">
      <div className="body">
        <div className="row w-100">
          <div>
            <span className="icon-container col-md-12 color-caribbean-green">
              <QesIcon iconName={providerSet.sourceProviderSetId ? QesIcons.FilterLines : QesIcons.UserV1} description={providerSet.sourceProviderSetId ? "Filtered network" : "Network" } />
            </span>
            <Link to={location} className="apply-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" title={providerSet.name}>
              {providerSet.name}
            </Link>
          </div>
        </div>
      </div>
    </div>);
}
